import {
  Badge,
  BottomNavigation,
  BottomNavigationAction,
  Box,
  BoxProps,
  useTheme,
} from "@mui/material";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";

import AccountIcon from "../assets/BottomNavbar/AccountIcon";
import BusinessIcon from "../assets/BottomNavbar/BusinessIcon";
import GigsIcon from "../assets/BottomNavbar/GigsIcon";
import MessagesIcon from "../assets/BottomNavbar/MessagesIcon";
import { Search } from "../assets/Icons";
import Tabs from "../constants/tabs";
import useCheckUnreadMessages from "../customHooks/useCheckUnreadMessages";
import { setTab } from "../redux/createTabSlice";
import { RootState } from "../redux/store";

const BottomNavbar = ({ sx, ...props }: BoxProps) => {
  const theme = useTheme();
  const activeTab = useSelector(
    (state: RootState) => state.activeTab.activeTab
  );
  const userUid = useSelector((state: RootState) => state.user.user.uid);
  const { notificationBadge, messageBadge } = useSelector(
    (state: RootState) => state.messaging
  );

  useCheckUnreadMessages("BottomNavbar");
  const router = useRouter();
  const dispatch = useDispatch();

  const shouldHide = router.asPath.includes("/auth/sign-up/create-account");

  return (
    <Box
      sx={{
        width: "100%",
        display: { xs: shouldHide ? "none" : "block", md: "none" },

        ...sx,
      }}
      {...props}
    >
      <BottomNavigation
        showLabels
        value={activeTab}
        sx={{
          "& .MuiBottomNavigationAction-label": {
            fontFamily: "Poppins",
            fontSize: "12px",
            mt: 1,
          },
        }}
      >
        <BottomNavigationAction
          label="Search"
          value={Tabs.Search}
          onClick={() => {
            router.push("/browse");
            dispatch(setTab(Tabs.Search));
          }}
          icon={
            <Search
              color={
                activeTab === Tabs.Search
                  ? theme.palette.primary.main
                  : theme.additionalColors.pastelBlue
              }
              dimension={24}
            />
          }
        />
        <BottomNavigationAction
          label="Message"
          value={Tabs.Message}
          onClick={() => {
            router.push(`/message`);
            dispatch(setTab(Tabs.Message));
          }}
          icon={
            <Badge
              variant="dot"
              color="error"
              invisible={notificationBadge && messageBadge}
              sx={{
                top: 2,
              }}
            >
              <Box>
                <MessagesIcon
                  color={
                    activeTab === Tabs.Message
                      ? theme.palette.primary.main
                      : theme.additionalColors.pastelBlue
                  }
                  dimension={24}
                />
              </Box>
            </Badge>
          }
        />
        <BottomNavigationAction
          label="Gigs"
          value={Tabs.Gigs}
          onClick={() => {
            router.push(`/gigs/${userUid}`);
            dispatch(setTab(Tabs.Gigs));
          }}
          icon={
            <GigsIcon
              color={
                activeTab === Tabs.Gigs
                  ? theme.palette.primary.main
                  : theme.additionalColors.pastelBlue
              }
              dimension={24}
            />
          }
        />
        <BottomNavigationAction
          label="Finance"
          value={Tabs.Finance}
          onClick={() => {
            router.push("/finance");
            dispatch(setTab(Tabs.Finance));
          }}
          icon={
            <BusinessIcon
              color={
                activeTab === Tabs.Finance
                  ? theme.palette.primary.main
                  : theme.additionalColors.pastelBlue
              }
              dimension={24}
            />
          }
        />
        <BottomNavigationAction
          label="Profile"
          value={Tabs.Profile}
          onClick={() => {
            router.push(`/profile/${userUid}`);
            dispatch(setTab(Tabs.Profile));
          }}
          icon={
            <AccountIcon
              color={
                activeTab === Tabs.Profile
                  ? theme.palette.primary.main
                  : theme.additionalColors.pastelBlue
              }
              dimension={24}
            />
          }
        />
      </BottomNavigation>
    </Box>
  );
};

export default BottomNavbar;
